<hyperkit-dialog class="hyperkit-component" headerText="Archive Hunt">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <hyperkit-typography variant="body" size="md" align="left" color="body">
          Are you sure you want to archive <strong>{{ hunt.name }}</strong
          >?</hyperkit-typography
        >
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Archive"
          (click)="onSubmit()"
        ></hyperkit-button>
      </div>
    </div>
  </div>
</hyperkit-dialog>
